var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2754_3351",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2754_3351)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "#F7FCFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2754_3351",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2754_3351)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V7.66667H23V0H0Z",
    fill: "#0080EC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.3335V23.0002H23V15.3335H0Z",
    fill: "#0080EC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 7.6665C11.6355 7.6665 11.7687 7.67899 11.8992 7.70316L11.7568 8.926C11.6728 8.91124 11.5871 8.90363 11.5 8.90363C11.3734 8.90363 11.2496 8.91973 11.1298 8.9505L11.0632 7.71046C11.2056 7.68151 11.3515 7.6665 11.5 7.6665ZM12.3281 7.8279L12.0783 9.02003C12.8713 9.34842 13.4472 10.3345 13.4472 11.4998C13.4472 11.5285 13.4468 11.557 13.4461 11.5854L14.3715 11.69C14.3738 11.627 14.375 11.5636 14.375 11.4998C14.375 9.76657 13.5122 8.30198 12.3281 7.8279ZM14.0253 13.3337C13.5697 14.4467 12.7123 15.2253 11.713 15.3228V14.0807C12.2453 14.0035 12.7133 13.6402 13.0285 13.1085L14.0253 13.3337ZM9.03957 13.4839C9.5168 14.5338 10.3613 15.2537 11.3355 15.327V14.0869C10.7678 14.0236 10.2692 13.6355 9.94482 13.0623L9.03957 13.4839ZM8.6276 11.6642C8.62587 11.6097 8.625 11.5549 8.625 11.4998C8.625 9.87217 9.38584 8.48144 10.4592 7.92542L10.6992 9.13268C10.0272 9.53747 9.55836 10.436 9.55289 11.4813L8.6276 11.6642Z",
    fill: "#D0AB00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4819 8.57666L9.51477 13.1103H13.4799L11.4819 8.57666Z",
    fill: "#7CDFFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2754_3351",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 8,
    width: 5,
    height: 6
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4819 8.57666L9.51477 13.1103H13.4799L11.4819 8.57666Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2754_3351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14.259C11.9717 14.259 12.3796 14.0035 12.661 13.6282C12.9425 13.253 13.1091 12.7462 13.1091 12.1969C13.1091 11.6476 12.9425 11.1407 12.661 10.7655C12.3796 10.3902 11.9717 10.1348 11.5 10.1348C11.0284 10.1348 10.6205 10.3902 10.339 10.7655C10.0576 11.1407 9.89093 11.6476 9.89093 12.1969C9.89093 12.7462 10.0576 13.253 10.339 13.6282C10.6205 14.0035 11.0284 14.259 11.5 14.259Z",
    stroke: "#E31D1C",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14.259C11.9717 14.259 12.3796 14.0035 12.661 13.6282C12.9425 13.253 13.1091 12.7462 13.1091 12.1969C13.1091 11.6476 12.9425 11.1407 12.661 10.7655C12.3796 10.3902 11.9717 10.1348 11.5 10.1348C11.0284 10.1348 10.6205 10.3902 10.339 10.7655C10.0576 11.1407 9.89093 11.6476 9.89093 12.1969C9.89093 12.7462 10.0576 13.253 10.339 13.6282C10.6205 14.0035 11.0284 14.259 11.5 14.259Z",
    stroke: "#FFD018",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14.259C11.9717 14.259 12.3796 14.0035 12.661 13.6282C12.9425 13.253 13.1091 12.7462 13.1091 12.1969C13.1091 11.6476 12.9425 11.1407 12.661 10.7655C12.3796 10.3902 11.9717 10.1348 11.5 10.1348C11.0284 10.1348 10.6205 10.3902 10.339 10.7655C10.0576 11.1407 9.89093 11.6476 9.89093 12.1969C9.89093 12.7462 10.0576 13.253 10.339 13.6282C10.6205 14.0035 11.0284 14.259 11.5 14.259Z",
    stroke: "#4EDD00",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14.259C11.9717 14.259 12.3796 14.0035 12.661 13.6282C12.9425 13.253 13.1091 12.7462 13.1091 12.1969C13.1091 11.6476 12.9425 11.1407 12.661 10.7655C12.3796 10.3902 11.9717 10.1348 11.5 10.1348C11.0284 10.1348 10.6205 10.3902 10.339 10.7655C10.0576 11.1407 9.89093 11.6476 9.89093 12.1969C9.89093 12.7462 10.0576 13.253 10.339 13.6282C10.6205 14.0035 11.0284 14.259 11.5 14.259Z",
    stroke: "#3D58DB",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.35681,
    y: 11.709,
    width: 4.49545,
    height: 1.74242,
    fill: "#3D58DB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.65778 12.4492L10.5538 11.2612L10.8287 11.8552L11.0208 11.1309L11.2342 11.6738L11.4583 11.2612L11.7482 11.6738L12.014 11.1309L12.2412 11.6738L12.502 11.2612L13.1111 12.1244L13.2208 12.4492L9.65778 12.6902V12.4492Z",
    fill: "#97C923"
  }))))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2754_3351)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2754_3351",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNio);
export default __webpack_public_path__ + "static/media/NIO.2ddf4dfb4d5164e5674d89da691d6e2b.svg";
export { ForwardRef as ReactComponent };